import { Accordion } from '@descomplica/foundation-ui-components';
import styled from 'styled-components';

export const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0 24px;
  overflow: hidden;

  @media (min-width: 768px) {
    padding: 0 45px;
  }

  @media (min-width: 1024px) {
    padding: 0 95px;
  }

  @media (min-width: 1280px) {
    padding: unset;
  }
`;

export const TitleContainer = styled.div`
  border-bottom: 1px solid #636769;
  margin-bottom: 16px;
`;

export const ThemeInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 16px;
`;

export const WriteEssayContainer = styled.div`
  display: grid;
  grid-template-columns: 3fr 7fr;
  gap: 16px;

  @media (max-width: 1024px) {
    grid-template-columns: 2fr 4fr;
    gap: 16px;
  }

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
  }
`;

export const ThemeTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #636769;
  padding: 24px 24px 24px 24px;
`;

export const SidebarContainer = styled.div``;

export const EssayTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;

  input {
    margin-bottom: 16px;
    background-color: transparent;
    border: 1px solid #96999c;
    padding: 12px 16px;
    border-radius: 8px;
    margin-bottom: 24px;
  }

  textarea {
    height: 100%;
    background-color: transparent;
    border: 1px solid #96999c;
    padding: 12px 16px;
    border-radius: 8px;
    resize: none;

    &::placeholder {
      color: #fff;
      opacity: 100%;
    }

    ::-webkit-scrollbar {
      width: 12px;
    }

    ::-webkit-scrollbar-thumb {
      background-color: #636769;
      border-radius: 3px;
    }

    ::-webkit-scrollbar-track {
      background-color: transparent;
    }
  }
`;

export const Title = styled.h1`
  font-size: 48px;
  font-style: normal;
  font-weight: 800;
  line-height: 52px;
  letter-spacing: -1.8px;
  text-align: left;
  margin-bottom: 16px;

  @media (max-width: 768px) {
    font-size: 48px;
    line-height: 52px;
    margin-top: 16px;
  }

  @media (max-width: 640px) {
    font-size: 32px;
    line-height: 1;
  }
`;

export const Breadcrumb = styled.span`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.6px;
  color: #caccce;
  cursor: pointer;
`;

export const ThemeInfo = styled.span`
  font-family: Aprova Nova;
  font-size: 24px;
  font-weight: 700;
  line-height: 36px;
  letter-spacing: -1px;
`;

export const EssayTitle = styled.span`
  font-family: Aprova Nova;
  font-size: 24px;
  font-weight: 700;
  line-height: 36px;
  letter-spacing: -1px;
  margin-bottom: 16px;
`;

export const ChangeThemeButton = styled.button`
  font-size: 16px;
  position: relative;
  line-height: 24px;
  letter-spacing: -0.6px;
  color: var(--color-primary-gray-05, #ddd);
  text-decoration: underline;
  cursor: pointer;
`;

export const ThemeTag = styled.span`
  font-family: Aprova Nova;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: -0.4px;
  text-align: left;
  color: #caccce;
`;

export const SendImageButton = styled.button`
  margin-bottom: 16px;
`;

export const ButtonText = styled.span`
  font-family: Aprova Nova;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  margin-left: 8px;
  text-decoration: underline;
`;

export const EssayInstructionsContainer = styled.div`
  border: 1px solid #636769;
  border-radius: 8px;
`;

export const SideTextWrapper = styled.div`
  height: 300px;
  overflow-x: hidden;
  overflow-y: scroll;

  ::-webkit-scrollbar {
    width: 12px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #636769;
    border-radius: 3px;
  }

  ::-webkit-scrollbar-track {
    background-color: transparent;
  }
`;

export const StyledAccordionItem = styled(Accordion.Item)`
  border-bottom: 1px solid #636769;
  padding: 24px 24px 12px 24px;
  margin-bottom: 0 !important;

  &:last-child {
    border-bottom: 0;
  }

  path {
    fill: #fff;
  }

  div > svg {
    position: relative;
    right: 24px;
    top: 24px;
  }
`;

export const EssayInstructions = styled.div`
  font-family: Aprova Nova;
  font-size: 16px;
  font-weight: 700;
  line-height: 16px;
  text-align: left;
  margin-bottom: 8px;
  margin-right: 8px;
`;

export const InputInfoContainer = styled.div`
  display: flex;
  margin-top: 16px;

  span {
    margin-right: 16px;
  }
`;

export const LineCountSpan = styled.span<{ error: boolean }>`
  color: ${(props) => (props.error ? `#ff3333` : `#ffffff`)};
`;

export const HighlightEssayButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  margin-top: 16px;

  @media (max-width: 640px) {
    flex-direction: column;
    justify-content: center;
    align-items: space-between;

    button {
      margin-top: 8px;
      width: 100%;
      margin-left: 0;
    }
  }
`;

export const DetailsButton = styled.button<{ disabled: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 20px 12px 24px;
  border-radius: 300px;
  margin-left: 16px;

  color: ${(props) => (!props.disabled ? `#191a1a` : `#636769`)};
  background-color: ${(props) => (!props.disabled ? `#00f99d` : `#f2f2f3`)};

  span {
    font-weight: 700;
    font-size: 14px;
    line-height: 14px;
    margin-left: 8px;
  }

  svg {
    width: 16px;
    height: 16px;
  }

  path {
    fill: black;
    max-width: 14px;
    max-height: 14px;
  }

  @media (max-width: 360px) {
    margin-right: unset;
  }
`;
